<template>
  <ListingsCheckboxFilter
    v-model="model"
    label="Show unactioned listings only?"
    explanation="Hides listings for homes where anyone in your team has opened or hidden an opportunity in the last 12 months."
  />
</template>

<script lang="ts" setup>
  // Components
  import ListingsCheckboxFilter from '~/misc/listings/filters/checkbox/ListingsCheckboxFilter.vue';

  const model = defineModel({
    type: Boolean,
    required: true,
  });
</script>
